export default __webpack_public_path__ + "static/media/FeedSpeedsImg.c2f23702.jpg";